import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { FlyingclubSummary } from '../models/flyingclub-summary.model';
import { BusinessManagerService } from '../../shared/user/business-manager.service';
var FlyingclubSummaryComponent = /** @class */ (function () {
    function FlyingclubSummaryComponent(businessManagerService) {
        this.businessManagerService = businessManagerService;
        this.isFlightDeckAdmin = false;
    }
    FlyingclubSummaryComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.businessManagerService.isFlightDeckAdmin()];
                    case 1:
                        _a.isFlightDeckAdmin = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(FlyingclubSummaryComponent.prototype, "iconUrl", {
        get: function () {
            if (this.flyingClub.clubType && this.flyingClub.clubType === 'AOPA Network Club') {
                return 'assets/icons/networkicon.png';
            }
            if (this.flyingClub.clubType && this.flyingClub.clubType === 'Club In Formation') {
                return 'assets/icons/informationicon.png';
            }
            return 'assets/icons/othericon.png';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FlyingclubSummaryComponent.prototype, "listingBackground", {
        get: function () {
            if (this.isFlightDeckAdmin && this.flyingClub.hideBusiness) {
                return 'not-ok';
            }
            else if (this.isFlightDeckAdmin && this.flyingClub.notApproved) {
                return 'not-approved';
            }
            else {
                return 'business-summary';
            }
        },
        enumerable: true,
        configurable: true
    });
    return FlyingclubSummaryComponent;
}());
export { FlyingclubSummaryComponent };
